import React, { Component } from 'react';
import { post } from '../../util/api';
import { connect } from 'react-redux';
import { updateProfile } from '../../actions/access.actions';
import { TextField, Button, Box, InputLabel, Select, MenuItem, FormControl } from '@mui/material';
import _ from 'lodash';
import Countries from './countries.json';

class UserPage extends Component {
	state = {
		userInfo: { icon: 'save', color: 'blue', saved: 'Save Information', sending: false },
		userPassword: { icon: 'save', color: 'blue', saved: 'Change Password', sending: false },
		companyName: this.props.user.company || (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.name) || '',
		vatNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.vatNumber) || '',
		country: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.country) || '',
		city: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.city) || '',
		state: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.state) || '',
		postcode: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.postcode) || '',
		street: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.street) || '',
	};

	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

	handleSubmit = (values) => {
		if (this.state.userInfo.sending) return;
		this.setState({ userInfo: { sending: true } });
		this.props.updateUser(values);
		this.setState({
			userInfo: { sending: false, errormessage: '', saved: 'Saved', color: 'teal', icon: 'check' },
		});
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ userInfo: { icon: 'save', color: 'blue', saved: 'Save' } });
		}, 2000);

		this.postData({
			companyName: this.state.companyName,
			vatNumber: this.state.vatNumber,
			country: this.state.country,
			city: this.state.city,
			state: this.state.state,
			street: this.state.street,
			postcode: this.state.postcode,
		});
	};
	postData(values) {
		let extra = _.merge(this.props.user.extra, {
			company: {
				name: values.companyName,
				vatNumber: values.vatNumber,
				country: values.country,
				state: values.state,
				city: values.city,
				street: values.street,
				postcode: values.postcode,
			},
		});
		post('/auth/updateInfo', {
			id: this.props.user.id,
			company: values.companyName,
			extra,
		});
	}
	render() {
		return (
			<div>
				{/* <h3 style={{ color: '#3f3f3f' }}>
					<Icon name="building" />
					Company Information
				</h3> */}
				<Box>
					<form onSubmit={this.handleSubmit}>
						<TextField
							fullWidth
							margin="normal"
							label="Company Name"
							name="companyName"
							iconPosition="left"
							placeholder="Enter your company name"
							type="text"
							value={this.state.companyName}
							onChange={this.handleChange}
						/>
						<TextField
							fullWidth
							margin="normal"
							id="vatNumber"
							label="Vat Number"
							icon="address card"
							required
							name="vatNumber"
							placeholder="Enter your vat number"
							iconPosition="left"
							type="text"
							value={this.state.vatNumber}
							onChange={this.handleChange}
						/>
						{/* <Form.Dropdown
							id="country"
							name="country"
							label="Country"
							placeholder="Select Country"
							search
							autoComplete="off"
							fluid
							required
							value={this.state.country}
							options={Countries}
							selection
							onChange={this.handleChange}
						></Form.Dropdown> */}

						<FormControl fullWidth margin="normal" sx={{ textAlign: 'left' }}>
							<InputLabel id="Country">Country</InputLabel>
							<Select
								labelId="Country"
								id="country"
								value={this.state.country}
								margin="normal"
								name="country"
								label="Country"
								onChange={this.handleChange}
							>
								{_.orderBy(Countries, ['text', 'value'], ['asc', 'desc']).map((items) => {
									return <MenuItem value={items.value}>{items.text}</MenuItem>;
								})}
							</Select>
						</FormControl>
						<TextField
							fullWidth
							margin="normal"
							id="state"
							label="State"
							iconPosition="left"
							name="state"
							icon="map"
							placeholder="Enter your state"
							type="text"
							value={this.state.state}
							onChange={this.handleChange}
						></TextField>
						<TextField
							fullWidth
							margin="normal"
							id="city"
							label="City"
							iconPosition="left"
							name="city"
							icon="map"
							required
							placeholder="Enter your city"
							type="text"
							value={this.state.city}
							onChange={this.handleChange}
						></TextField>
						<TextField
							fullWidth
							margin="normal"
							id="street"
							label="Street"
							iconPosition="left"
							name="street"
							icon="map"
							required
							placeholder="Enter your street"
							type="text"
							value={this.state.street}
							onChange={this.handleChange}
						></TextField>
						<TextField
							fullWidth
							margin="normal"
							id="postcode"
							label="Post Code (**)"
							iconPosition="left"
							name="postcode"
							icon="address card"
							required={_.includes(['AU', 'CA', 'DE', 'ES', 'FR', 'GB', 'IN', 'IT', 'NL', 'US'], this.state.country)}
							placeholder="Enter your postcode"
							value={this.state.postcode}
							onChange={this.handleChange}
						></TextField>
						<Button
							id="company-get"
							sx={{
								':hover': {
									color: '#fafafa',
									backgroundColor: 'rgb(0 102 178) !important',
								},
							}}
							fullWidth
							style={{ background: '#2185d0' }}
							size="large"
							type="submit"
							variant="contained"
							content={this.state.userInfo.saved}
							loading={this.state.userInfo.sending}
						>
							Save Changes
						</Button>
					</form>
				</Box>
			</div>
		);
	}
}

export default connect(
	(state) => ({ user: state.access.user.loggedUserObj }),
	(dispatch) => ({ updateUser: (user) => dispatch(updateProfile(user)) })
)(UserPage);
